module.exports = {
      id: "success-circle-usage",
      viewBox: "0 0 89 88",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#success-circle",
      toString: function () {
        return this.url;
      }
    }